import i18n from "i18next";
import Backend from "i18next-http-backend";
import type { HttpBackendOptions } from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const ENABLE_BETA_LOCALES = JSON.parse(process.env.REACT_APP_ENABLE_BETA_LOCALES || "false");

const PROD_SUPPORTED_LANGUAGES = ["en", "zh-CN", "es", "ja", "pl", "pt-BR"] as const;
const DEV_EXTRA_SUPPORTED_LANGUAGES = ["it", "el-GR"] as const;

const SUPPORTED_LANGUAGES = ENABLE_BETA_LOCALES
  ? ([...PROD_SUPPORTED_LANGUAGES, ...DEV_EXTRA_SUPPORTED_LANGUAGES] as const)
  : [...PROD_SUPPORTED_LANGUAGES];

type SupportedLocales = StringAutocomplete<(typeof SUPPORTED_LANGUAGES)[number]>;

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init<HttpBackendOptions>({
    debug: process.env.REACT_APP_DEBUG_I18N === "true",
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    react: { useSuspense: true },
    interpolation: { escapeValue: false }, // react already safes from xss},
    // parseMissingKeyHandler: () => "🍞", // replace with the following text to find change all translations
  });

export { SUPPORTED_LANGUAGES as supportedLngs };
export type { SupportedLocales };

export default i18n;
